import React, { FC, useState } from 'react';
import './App.css';
import { useMutation, useQuery, useReactiveVar } from '@apollo/client';
import { CssBaseline } from '@mui/material';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { denthubTheme } from 'theme/base';
import App from 'App';
import Login from 'pages/login/login.component';
import Loader from 'components/shared/loader/loader.component';
import { apolloClient } from 'apollo/client';
import { isSignedInVar } from 'apollo/reactive-vars';
import { logoutTemplate, meTemplate } from 'apollo/templates/super-admin';
import { SuperAdmin } from 'models/super-admin';
import { setErrorReportingUser } from 'error-reporting/error-reporting';
import {
    DenthubErrorBoundaryProvider,
    UserFrontendFeedbackDialog,
} from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';

const AppContainer: FC = () => {
    // Iframe buster
    // eslint-disable-next-line no-restricted-globals
    if (top !== self && top) {
        // eslint-disable-next-line no-restricted-globals
        top.location = location as any;
    }

    const isSignedIn = useReactiveVar(isSignedInVar);
    const [admin, setAdmin] = useState<SuperAdmin>();

    const { loading } = useQuery<{ me: SuperAdmin | null }>(meTemplate, {
        fetchPolicy: 'network-only',
        onCompleted: ({ me }) => {
            if (me) {
                setAdmin(me);
                isSignedInVar(true);
                setErrorReportingUser({ _id: me._id, email: me.email, fullName: me.name });
            }
        },
    });

    const [logout] = useMutation(logoutTemplate, {
        onCompleted: async () => {
            isSignedInVar(false);
            setAdmin(undefined);
            setErrorReportingUser();
            await apolloClient.clearStore();
        },
    });

    const onLoggedIn = (loggedIn: SuperAdmin) => {
        setAdmin(loggedIn);
        isSignedInVar(true);
    };

    let content;
    if (loading) {
        content = <Loader />;
    } else if (isSignedIn && admin) {
        content = (
            <DenthubErrorBoundaryProvider>
                <App admin={admin} onLogout={() => logout()} />
                <UserFrontendFeedbackDialog />
            </DenthubErrorBoundaryProvider>
        );
    } else {
        content = <Login onLoggedIn={onLoggedIn} />;
    }

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={denthubTheme}>
                <CssBaseline />
                {content}
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default AppContainer;
